import type { TranslationFunction } from 'tradera/lang/translate';

export enum SHIPPING_OPTIONS {
    ALTERNATIVE = 'Alternative',
    ALTERNATIVE_DENMARK = 'AlternativeDenmark',
    BRING_DENMARK = 'BringDenmark',
    BUSSGODS = 'Bussgods',
    DHL = 'DHL',
    FEDEX = 'FedEx',
    NOT_SPECIFIED = 'NotSpecified',
    POSTNORD = 'Posten',
    POSTNORD_PARCEL = 'PostNordParcel',
    POSTNORD_STAMP = 'PostNordStamp',
    POSTNORD_STAMP_DENMARK = 'PostNordStampDenmark',
    SCHENKER = 'SchenkerPrivpak',
    TAKE_AWAY = 'Takeaway',
    TAKE_AWAY_ONLY = 'TakeawayOnly',
    UPS = 'Ups'
}

interface ShippingProvider {
    text: string;
    type: SHIPPING_OPTIONS;
    logoImgUrl: string | null;
}

const shippingProviders = (t: TranslationFunction): ShippingProvider[] => [
    {
        text: t('shippingProviders_schenkerPrivpak'),
        type: SHIPPING_OPTIONS.SCHENKER,
        logoImgUrl: '/static/images/shipping/schenker.svg'
    },
    {
        text: t('shippingProviders_posten'),
        type: SHIPPING_OPTIONS.POSTNORD,
        logoImgUrl: '/static/images/shipping/postnord.svg'
    },
    {
        text: t('shippingProviders_postNordParcel'),
        type: SHIPPING_OPTIONS.POSTNORD_PARCEL,
        logoImgUrl: '/static/images/shipping/postnord.svg'
    },
    {
        text: t('shippingProviders_postNordStamp'),
        type: SHIPPING_OPTIONS.POSTNORD_STAMP,
        logoImgUrl: '/static/images/shipping/postnord.svg'
    },
    {
        text: t('shippingProviders_postNordStamp'),
        type: SHIPPING_OPTIONS.POSTNORD_STAMP_DENMARK,
        logoImgUrl: '/static/images/shipping/postnord.svg'
    },
    {
        text: t('shippingProviders_dhl'),
        type: SHIPPING_OPTIONS.DHL,
        logoImgUrl: '/static/images/shipping/dhl.svg'
    },
    {
        text: t('shippingProviders_bussgods'),
        type: SHIPPING_OPTIONS.BUSSGODS,
        logoImgUrl: '/static/images/shipping/bussgods.svg'
    },
    {
        text: t('shippingProviders_bringDenmark'),
        type: SHIPPING_OPTIONS.BRING_DENMARK,
        logoImgUrl: '/static/images/shipping/bring.svg'
    },
    {
        text: t('shippingProviders_alternative'),
        type: SHIPPING_OPTIONS.ALTERNATIVE,
        logoImgUrl: null
    },
    {
        text: t('shippingProviders_alternative'),
        type: SHIPPING_OPTIONS.ALTERNATIVE_DENMARK,
        logoImgUrl: null
    },
    {
        text: t('shippingProviders_takeaway'),
        type: SHIPPING_OPTIONS.TAKE_AWAY,
        logoImgUrl: null
    },
    {
        text: t('shippingProviders_takeaway'),
        type: SHIPPING_OPTIONS.TAKE_AWAY_ONLY,
        logoImgUrl: null
    },
    {
        text: t('shippingProviders_notSpecified_full'),
        type: SHIPPING_OPTIONS.NOT_SPECIFIED,
        logoImgUrl: null
    }
];

const shippingProvidersMap = (
    t: TranslationFunction
): Record<SHIPPING_OPTIONS, ShippingProvider> =>
    shippingProviders(t).reduce(
        (obj, provider) => ({
            ...obj,
            [provider.type]: provider
        }),
        {} as Record<SHIPPING_OPTIONS, ShippingProvider>
    );

export const isStampProvider = (provider: SHIPPING_OPTIONS): boolean =>
    [
        SHIPPING_OPTIONS.POSTNORD_STAMP,
        SHIPPING_OPTIONS.POSTNORD_STAMP_DENMARK
    ].indexOf(provider) !== -1;

export default {
    get: (t: TranslationFunction) => shippingProviders(t),
    map: (t: TranslationFunction) => shippingProvidersMap(t)
};
